import dynamic from 'next/dynamic';
import { LegalConsentProps } from './LegalConsent.types';

export const LegalConsent = dynamic<LegalConsentProps>(() =>
  import('./LegalConsents').then(module => module.LegalConsent)
);
